// Read-only accessors for the Course -> Subject -> Chapter -> Topic -> Sub-Topic
// hierarchy, used by the tabs that only need to pick from it (Questions,
// Videos, Tests, Students, ...). They are backed by the real admin API (see
// src/api/assessmentHierarchy.js) and return the full collection at each level.
// The hierarchy tabs themselves call the API module directly for writes.
import {
  listCourses,
  listAllSubjects,
  listAllChapters,
  listAllTopics,
  listAllSubTopics,
} from "../../api/assessmentHierarchy";
import { slugify } from "./assessmentLocalStore";

export { slugify };

export const COURSE_TYPES = [
  "National-level Entrance",
  "State-level Entrance",
  "University-level Entrance",
  "Medical Entrance",
  "Engineering Entrance",
  "Management Entrance",
  "Recruitment/Professional Entrance",
];

export const getCourses = () => listCourses({ includeInactive: true });
export const getSubjects = () => listAllSubjects();
export const getChapters = () => listAllChapters();
export const getTopics = () => listAllTopics();
export const getSubTopics = () => listAllSubTopics();

// Ids are integers server-side but often arrive as strings from <Select>/route
// params, so compare loosely via String().
const byId = (rows, id) => rows.find((r) => String(r.id) === String(id));

export const getCourseById = (id) => getCourses().then((rows) => byId(rows, id));
export const getSubjectById = (id) => getSubjects().then((rows) => byId(rows, id));
export const getChapterById = (id) => getChapters().then((rows) => byId(rows, id));
export const getTopicById = (id) => getTopics().then((rows) => byId(rows, id));
export const getSubTopicById = (id) => getSubTopics().then((rows) => byId(rows, id));
